import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c5f22030&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c5f22030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f22030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5f22030')) {
      api.createRecord('c5f22030', component.options)
    } else {
      api.reload('c5f22030', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c5f22030&scoped=true&", function () {
      api.rerender('c5f22030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JeUg70LP9J7A/JS/comp/SearchFilterTokens.vue"
export default component.exports